export const SET_USER = "SET_USER";
export const SET_ITEMS = "SET_ITEMS";
export const SET_TEMPLATES = "SET_TEMPLATES";
export const LOG_OUT = null;
